import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const ChevronLeftIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 24 24" fill="none">
      <path
        d="M13 18L8 12L13 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default React.memo(ChevronLeftIcon);
